/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { GetOrderRequest } from '../model/getOrderRequest';
import { GetOrderResponse } from '../model/getOrderResponse';
import { SearchDecryptionRequest } from '../model/searchDecryptionRequest';
import { SearchDecryptionResponse } from '../model/searchDecryptionResponse';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class DefaultService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 予約詳細情報をDxAPIから取得・返却する&lt;br/&gt; Prebook状態の予約については原則検索エラーとするが、新規フローの場合でカート情報が残っている場合はPrebook状態のPNRを返却する。&lt;br/&gt;&lt;br/&gt;  ### 【アクセス情報】&lt;br&gt; 外部からの呼び出しは、以下のURLとする。   | 環境 | URL |  | :--- | :--- |  | 本番 | https://space.ana.co.jp/aswbe-servicing/api/v1/orders/get-order |  | ステージング | https://stg.test.space.ana.co.jp/stg1/aswbe-servicing/api/v1/orders/get-order&lt;br&gt;https://stg.test.space.ana.co.jp/stg2/aswbe-servicing/api/v1/orders/get-order |  | 開発 | https://dev.test.space.ana.co.jp/dev1/aswbe-servicing/api/v1/orders/get-order&lt;br&gt;https://dev.test.space.ana.co.jp/dev2/aswbe-servicing/api/v1/orders/get-order&lt;br&gt;https://dev.test.space.ana.co.jp/dev3/aswbe-servicing/api/v1/orders/get-order&lt;br&gt;https://dev.test.space.ana.co.jp/dev4/aswbe-servicing/api/v1/orders/get-order&lt;br&gt;https://dev.test.space.ana.co.jp/dev5/aswbe-servicing/api/v1/orders/get-order |  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;    エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br/&gt; 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;   有効でない場合、ステータスコード401でエラー情報を返して、本処理を中止とする。  1. リクエストパラメータに予約番号、航空券番号、カートIDのいずれも存在しない、またはそれらの内、予約番号とカートID以外の組み合わせにて2つ以上の指定がある場合、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br/&gt; 1. リクエストパラメータに予約番号または航空券番号が存在し、credentialファイル情報が存在しない場合、ステータスコード400(Bad request)でエラー情報を返却する。 1. リクエストパラメータにカートIDが指定されている場合、カートIDをもとにDxAPIよりカート情報を取得する。&lt;br/&gt;   カート情報が取得できない場合、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br/&gt; 1. 予約番号、または航空券番号と姓名をもとにDxAPIから予約詳細情報を取得する。&lt;br/&gt;   予約番号をもとに取得する際は、カート情報が存在する場合はカート情報に含まれる予約番号を使用する。存在しない場合はリクエストパラメータに指定されている予約番号を使用する。&lt;br/&gt;   DxAPIからPNR情報を取得できなかった場合はステータスコード400でエラー情報を返して、本処理を中止とする。&lt;br/&gt; 1. 以下のいずれかに該当する場合、ステータスコード400でエラー情報を返して、本処理を中止とする。エラーコードは合致した条件毎に異なるエラーコードとする。&lt;br/&gt;   1. 検索時に指定した姓名と一致する搭乗者が存在しない&lt;br/&gt;   1. 複数のPNRが返却された 1. PNRが以下いずれかに合致する場合はASW取り扱い不可とし、ステータスコード400でエラー情報を返して、本処理を中止とする。&lt;br/&gt;    エラーコードは合致した条件毎に異なるエラーコードとする。   1. チャーター認識(フリーテキストが\&quot;CHTR\&quot;で始まるOSIエレメント)が存在するPNR   1. リクエストパラメータにカートIDが存在しない、かつPrebook予約のPNRとして、以下の条件を全て満たす     1. PNRオーナーオフィスIDがASWDB(マスタ)のオフィスマスタに存在する     1. コードがTIMEであるSSR(Keep My FareのSSR)が存在しない     1. 特典の減算を含む航空券のFPエレメントについて、以下を全て満たすものが存在しない        1. FPエレメントのFOPコード(DxAPIからはidとして返却されるコード)がWBCASHまたはWCCASHである        1. 払込期限(※)が存在し、現在時刻を過ぎていない&lt;br/&gt;        ※FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの4番目に払込期限がyyyyMMddHHmmss形式で返却される。     1. DxAPIから有効期限、支払期限、発券期限の3つ全てが返却されている     1. RMエレメントに予約のみで完了を示す所定の文字列(設定ファイルにて管理)が存在しない   1. 旅程が存在しない、またはセグメントステータスがゴーストセグメント(設定ファイルに定義)のセグメントのみ   1. コールセンター払戻受付認識(フリーテキストが\&quot;IRRF\&quot;で始まるRMエレメント(設定ファイルに定義))が存在する   1. 支払方法がコンビニ支払だが、決済番号が存在しない&lt;br/&gt;      ※FPエレメントのFOPコード(DxAPIからはidとして返却されるコード)がWCCASHである場合、支払方法がコンビニ支払であるとする。&lt;br/&gt;      ※FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの3番目に決済番号が返却される。   1. 以下の条件を全て満たす     1. リクエストパラメータに予約番号が存在する。     1. 別APIからの内部呼び出しではない。     1. DxAPIよりグループPNR識別が返却されている。   1. 空席待ちセグメントがあり、購入(nextAction.payment)がtrueかつ、現在時刻が購入期限(nextAction.paymentDetails.paymentDeadline)を過ぎている   1. 特典PNR用コールセンター払戻受付識別(フリーテキストが\&quot;MLRF\&quot;で始まるRMエレメント(設定ファイルに定義))が存在する   1. 特典PNR用Dynamic Waiver対象便払戻受付識別(フリーテキストが\&quot;BFRF\&quot;または\&quot;AFRF\&quot;で始まるRMエレメント(設定ファイルに定義))が存在する 1. 以下のいずれかに該当する場合、DxAPIに運賃再計算のリクエストを送信する。   1. SSR FQTRが存在せず、PNRオーナーオフィスIDの4-6桁目がNH0であり、かつ航空券のFPエレメントが何も存在しない、日本国内単独旅程である予約 1. 運賃再計算のリクエストを送信した場合、以下の処理を行う。   1. 運賃再計算のリクエストが正常終了した場合、処理6～処理8を再度実施する。   1. 運賃再計算のリクエストでエラーが発生した場合、処理は中止せず、リクエスト前に取得していた予約詳細情報で処理を継続する。 1. 予約番号、姓名をもとにDxAPIからサービスカタログ情報を取得する。ただし、以下のいずれかに該当する場合は取得しない。   1. 旅程にセグメントステータスがコールセンター要確認、スケジュールチェンジ発生のセグメントを含む ※要確認ステータス、スケジュールチェンジ発生はそれぞれ設定ファイルに定義    1. フリーテキストに\&quot;WEB//@IGNORE\&quot;を含むRMエレメントが存在する     1. ASWで定めるPNR更新不可旅客種別(設定ファイルに定義)のみのPNR    1. 旅程内に、便名、出発日、suffix識別が重複し、セグメントステータスが両方とも確定済み(設定ファイルに定義)となるセグメントが存在する&lt;br/&gt;   ※suffix識別がない場合は「suffix識別なし」として重複かどうかを判定する   1. コードがCBBG/EXSTであるSSRエレメントが存在する    1. acknowledge、self reaccommodationのいずれかが案内要である　※詳細は案内・利用可否のイレギュラー振替を参照    1. リクエストパラメータのサービスカタログ取得要否がfalse 1. 予約番号、姓名をもとにDxAPIから滞在資格証明ドキュメント情報登録要否情報を取得する。取得に失敗した場合は本処理を中止し、400エラーを返却する。 1. DxAPIよりグループPNR識別が返却されている場合、DxAPIから返却された搭乗者情報から、リクエストパラメータの姓名と一致しない搭乗者の情報を削除する。 1. リクエストパラメータに搭乗者リストが指定されている場合、指定された搭乗者以外の搭乗者の情報を削除する。以下に該当する場合は本処理を中止し、400エラーを返却する。   1. 搭乗者リストの搭乗者が、DxAPIから返却された搭乗者情報に存在しない   1. 搭乗者リストの搭乗者が、DxAPIから返却された搭乗者情報に複数存在する 1. リクエストパラメータの自動Ack処理可否が可かつ、自動Ack対象バウンドがある、かつacknowledge案内要否が要、かつacknowledge利用可否が可、かつacknowledgeのコールセンターにて対応が必要かどうかが不要の場合、以下の処理を行う。&lt;br/&gt;   ※詳細は旅程情報のバウンドリストの自動Ack対象バウンドかどうか、案内・利用可否のイレギュラー振替のacknowledgeを参照   1. Acknowledge確定APIを呼び出し、自動Ackを行う。Acknowledge確定APIでエラーが発生した場合、ステータスコード400でエラー情報を返して、本処理を中止とする。   1. 処理5～処理13を再度実施する。 1. 操作日時がDCS移行開始前日以降(設定ファイルに定義)、かつ操作日時 &gt; セグメントの出発日前日の22:15となるセグメントが存在する場合、該当セグメントについて、&lt;br/&gt;   ASWDB(Tx)のフライト毎のWi-Fi利用可否情報からWi-Fi利用区分を取得する。尚、タイムゾーンは操作日時、出発日ともにJSTとする。&lt;br/&gt;   ASWDB(Tx)からWi-Fi利用区分が取得できなかった場合、CASよりWi-Fi利用可否を取得してASWDB(Tx)に登録する。&lt;br/&gt;   CASからWi-Fi利用可否が取得できなかった場合、Wi-Fi利用可否の取得に失敗した旨のワーニング情報を設定する。 1. 出発まで48時間以内であるセグメントが存在する場合、そのセグメントを指定して発着APIを呼び出し発着情報を取得する。 1. クーポンステータスがチェックイン済みの航空券がリレートしているセグメントが存在する場合、予約番号を基にDxAPIよりCPR情報を取得する。 1. 以下の全ての条件に該当する場合、予約情報連携URLに対してHTTPS通信にて予約情報（※）を送信し、企業への予約情報連携を行う。&lt;br/&gt; 送信に失敗した場合、ANA Biz APIの未送信データ登録処理を呼び出し、送信失敗した情報をANA Biz DBへ登録する。登録時は、送信失敗したXMLをそのまま登録する。未送信データ登録も失敗した場合、ANA Biz未送信データ登録失敗ワーニングとする。※ xxx/IF定義書_予約情報データ連携参照。   1. リクエストパラメータの予約情報を送信するか否かがtrueであり、かつANA Bizログインユーザ情報に企業への予約情報連携URLが存在する   1. PNRオーナーオフィスコードが、設定ファイルに定義されるANA Bizオフィスコードに該当する 1. 未購入かつANA Bizログインユーザの企業情報が発券要求機能を使用可能の場合、以下の処理を行う。   1. 処理区分に「発券要求情報1件取得」、ロールにANA Bizログインユーザ情報の承認者権限フラグが「権限あり」の場合は「承認者」、そうでない場合は「出張者」を指定して&lt;br/&gt;     ANA Biz APIの発券要求取得処理を呼び出し、同一予約に対する発券要求情報リストを取得する。 1. 取得した予約詳細情報をもとにレスポンスボディの内容でPNR情報をステータスコード200(OK)で返却する。  # 3. データ更新内容 なし  # 4. 特記事項 1. 搭乗者の名前情報(搭乗者名、搭乗者ミドルネーム、搭乗者姓)について、DxAPIでは先頭大文字、2文字目以降が小文字で返却される。    ASW上では全て大文字にて表現する必要があるため、DxAPIから取得する予約詳細情報の内、搭乗者の名前情報をシステム層APIにて大文字に変換したものを取得する。 1. 搭乗者の姓名一致確認を行う場合は、次の点に留意する。   1. PNRの搭乗者名(名)と、入力された搭乗者名(名)、または、S2パーソナライズ情報のログインユーザ名からそれぞれスペースを除いて比較を行う。(搭乗者名(名)に対して「ミドルネーム＋半角スペース＋名」が返ってくることを想定している。)   1. PNRの搭乗者名(名)から設定ファイルに定義したタイトルを除いたものと、入力された搭乗者名(名)、または、S2パーソナライズ情報のログインユーザ名で比較を行う。(搭乗者名(名)に対して「名＋タイトル」が返ってくることを想定している。) 1. 航空券(documentTypeが\&quot;eticket\&quot;)の発券済判定について&lt;br/&gt;   travelDocuments配下のareCouponsAndSegmentsInSyncがtrueの時はFA・falseの時はFHEと判断する想定だったが、&lt;br/&gt;   PNR上FAが無くFHEのみ存在する場合にareCouponsAndSegmentsInSyncがtrueかつstatusが存在しない状態でDxAPIから返却されることが判明したため、以下のように判断する。&lt;br/&gt;   1. areCouponsAndSegmentsInSyncがtrueかつstatusが\&quot;ISSUED\&quot;の場合、FAかつ発券済   1. areCouponsAndSegmentsInSyncがtrueかつstatusが存在しない場合、FHEかつ発券済   1. areCouponsAndSegmentsInSyncがfalseの場合、FHEかつ発券済
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public ordersGetOrderPost(
    generated?: GetOrderRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetOrderResponse>;
  public ordersGetOrderPost(
    generated?: GetOrderRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetOrderResponse>>;
  public ordersGetOrderPost(
    generated?: GetOrderRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetOrderResponse>>;
  public ordersGetOrderPost(
    generated?: GetOrderRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/orders/get-order`;
    return this.httpClient.request<GetOrderResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 暗号化された予約検索パラメータの復号、パラメータの検証を行い、詳細パラメータの分割をして項目を返却する。&lt;br/&gt;&lt;br/&gt; # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用して&lt;br/&gt;   Mulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br/&gt;   ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;   有効でない場合、ステータスコード401でエラー情報を返して、本処理を中止とする。 1. リクエストで受け取ったパラメータを基に、以下の項目検証を行う。&lt;br/&gt;   検証がNGの場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。   1. 処理区分がシームレス連携の場合、TTYPNR連携キーの項目が指定されていること   1. 処理区分がINFINI・Galileo連携の場合、サイトID、暗号化方式、INFINI、Galileo専用キー項目の暗号化連携データ、連携データハッシュ値の項目が全て指定されていること、&lt;br/&gt;      かつ、国コードが”JPN”、言語コードが”ja” または”en”であること   1. 処理区分が国内ASW連携の場合、国内ASW連携専用キー項目の暗号化連携データが指定されていること 1. 処理区分がシームレス連携の場合、以下の内容で復号を行う。   1. TTYPNR連携キーを16進表記の文字列からバイナリに変換し、さらにBlowFish方式で復号する。復号に必要な情報は設定ファイルより取得する。&lt;br/&gt;      変換、復号に失敗または復号した文字列の文字数が62文字以外の場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。   1. 復号した文字列を6/25/25/6桁の4つに分割し、順に予約番号、旅客名(姓)、旅客名(名)、企業IDとする。&lt;br/&gt;      企業IDが設定ファイルにシームレス連携サイト企業IDに含まれない場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。 1. 処理区分がINFINI・Galileo連携の場合、以下の内容で復号を行う。   1. INFINI、Galileo専用キー項目の暗号化連携データを16進表記の文字列からバイナリに変換し、さらに暗号化方式で指定された方式（AES）で復号する。&lt;br/&gt;      復号に必要な情報は設定ファイルより取得する。&lt;br/&gt;      連携データハッシュ値は16進数でエンコードされているため、デコードを実施する。サイトID、暗号化方式、復号後のINFINI、Galileo専用キー項目の暗号化連携データ、&lt;br/&gt;      国コード、言語コードを連結しMD5でハッシュ値を算出する。&lt;br/&gt;      変換、復号に失敗または復号した文字列を用いて算出したハッシュ値とデコードした連携データハッシュ値が一致しないの場合、ステータスコード400(Bad Request)で&lt;br/&gt;      エラー情報を返して、本処理を中止とする。   1. 復号した文字列をカンマ区切りで分割し、順に予約番号、旅客名(姓)、旅客名(名)、航空券番号、便名、搭乗月、搭乗日、AMC会員番号、URL生成日付とする。&lt;br/&gt;      分割した項目が９つ以外、またはURL生成日付が規定時間内（設定ファイルより取得）でない場合、ステータスコード400(Bad Request)でエラー情報を返して、&lt;br/&gt;      本処理を中止とする。 1. 処理区分が国内ASW連携の場合、以下の内容で復号を行う。   1. 国内ASW連携専用キー項目の暗号化連携データを16進表記の文字列からバイナリに変換し、さらにBlowFish方式で復号する。復号に必要な情報は設定ファイルより取得する。&lt;br/&gt;      変換、復号に失敗した場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。   1. 復号した文字列をアンパサンド（＆）区切りで分割し、順に予約番号、航空券番号、旅客名(姓)、旅客名(名)とする。&lt;br/&gt;      分割した項目が４つでない場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止する。 1. ステータスコード200を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public ordersSearchDecryptionPost(
    generated?: SearchDecryptionRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<SearchDecryptionResponse>;
  public ordersSearchDecryptionPost(
    generated?: SearchDecryptionRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<SearchDecryptionResponse>>;
  public ordersSearchDecryptionPost(
    generated?: SearchDecryptionRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<SearchDecryptionResponse>>;
  public ordersSearchDecryptionPost(
    generated?: SearchDecryptionRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/orders/search-decryption`;
    return this.httpClient.request<SearchDecryptionResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
